<style lang="less">

</style>

<template>
  <div id="back-top"><i class="iconfont icon-scroll-top scroll-up"></i></div>
</template>

<script>
  export default {
    name: "back-top"
  }
</script>
